import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const authRoutes = [
  <Route
    key="login"
    exact
    path="/login"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Login")}
      />
    )}
  />,
  <Route
    key="logintoken"
    exact
    path="/logintoken"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/LoginWithToken")}
      />
    )}
  />,
  <Route key="register" exact path="/register" render={() => <Redirect to="/login" />} />,
  <Route key="register-verification" exact path="/register/verification" render={() => <Redirect to="/login" />} />,
  <Route key="register-basic-info" exact path="/register/basic_info" render={() => <Redirect to="/login" />} />,
  <Route key="register-choose-program" exact path="/register/choose_program" render={() => <Redirect to="/login" />} />,
  <Route key="register-more-info" exact path="/register/more_info" render={() => <Redirect to="/login" />} />,
  <Route key="register-invoices" exact path="/register/invoices" render={() => <Redirect to="/login" />} />,
  <Route key="password-reset" exact path="/passwordreset" render={() => <Redirect to="/login" />} />,
  <Route
    key="delete-account"
    exact
    path="/delete_account"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/DeleteAccount")}
      />
    )}
  />
];

export default authRoutes; 